module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('company-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.company.name
    },
    model: {
      value: (_vm.$attrs.company.name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.company, "name", $$v)
      },
      expression: "$attrs.company.name"
    }
  }), _vm._v(" "), _c('bill-template-field', {
    attrs: {
      "error": _vm.$attrs.errors.company.bill_template
    },
    model: {
      value: (_vm.$attrs.company.bill_template),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.company, "bill_template", $$v)
      },
      expression: "$attrs.company.bill_template"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0635ae67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/company/CompanyFormBlank.vue
// module id = 571
// module chunks = 0